import moment from "moment";
import { useEffect, useState } from "react";
import Loader from "../../components/loader";
import WebLayout from "../../layout/WebLayout";
import NoRecord from "../../components/NoRecord";
import PanelLayout from "../../layout/PanelLayout";
import { webPaths } from "../../routes/pageRoutes";
import { handleShareUserProfile, pipGetAccessToken } from "../../utils/pip";
import { useDispatch, useSelector } from "react-redux";
import AssetCard from "../../components/pages/AssetCard";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { fetchUserDetail } from "../../redux/actions/assetAction";

const OwnerDetail = () => {
  const { id } = useParams();
  const { isLogin } = pipGetAccessToken();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const fromPage = location.state?.from;
  const [searchTerm, setSearchTerm] = useState("");

  const { isLoading, userData, relatedAssetList } = useSelector(
    (state) => state.assetReducer,
  );
  const filteredAssets =
    relatedAssetList.filter((sub) =>
      sub?.AssetName?.toLowerCase().includes(searchTerm?.toLowerCase()),
    ) || [];
  useEffect(() => {
    dispatch(fetchUserDetail(id));
  }, [id]);

  const render = () => {
    return (
      <>
        <div class="assets-detail-content ct_py_80">
          <div class="container">
            {/* Header */}
            <div class="d-flex align-items-center justify-content-between mb-4">
              <h1 class="ct_fs_24 ct_fw_600">
                {" "}
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(-1);
                  }}
                  class="ct_back_icon ct_fs_18"
                >
                  <i class="fa-solid fa-angle-left"></i>
                </a>
                User Profile
              </h1>
              <div class="header-actions d-flex gap-3 flex-wrap align-items-center">
                <a
                  class="ct_text_clr_4B5563 d-flex align-items-center"
                  data-bs-target="#mobileAppModal"
                  data-bs-toggle="modal"
                >
                  <svg
                    className="me-2"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.0003 13.3334V10M10.0003 6.66669H10.0087M1.66699 7.10231V12.8977C1.66699 13.1016 1.66699 13.2035 1.69002 13.2994C1.71043 13.3844 1.7441 13.4657 1.78979 13.5403C1.84133 13.6244 1.91339 13.6964 2.05752 13.8405L6.1598 17.9428C6.30393 18.087 6.37599 18.159 6.46009 18.2106C6.53465 18.2562 6.61594 18.2899 6.70097 18.3103C6.79687 18.3334 6.89878 18.3334 7.10261 18.3334H12.898C13.1019 18.3334 13.2038 18.3334 13.2997 18.3103C13.3847 18.2899 13.466 18.2562 13.5406 18.2106C13.6247 18.159 13.6967 18.087 13.8408 17.9428L17.9431 13.8405C18.0873 13.6964 18.1593 13.6244 18.2109 13.5403C18.2565 13.4657 18.2902 13.3844 18.3106 13.2994C18.3337 13.2035 18.3337 13.1016 18.3337 12.8977V7.10231C18.3337 6.89848 18.3337 6.79657 18.3106 6.70066C18.2902 6.61563 18.2565 6.53434 18.2109 6.45978C18.1593 6.37569 18.0873 6.30362 17.9431 6.1595L13.8408 2.05721C13.6967 1.91308 13.6247 1.84102 13.5406 1.78949C13.466 1.7438 13.3847 1.71013 13.2997 1.68971C13.2038 1.66669 13.1019 1.66669 12.898 1.66669H7.10261C6.89878 1.66669 6.79687 1.66669 6.70097 1.68971C6.61594 1.71013 6.53465 1.7438 6.46009 1.78949C6.37599 1.84102 6.30393 1.91308 6.1598 2.05721L2.05752 6.1595C1.91339 6.30362 1.84133 6.37569 1.78979 6.45978C1.7441 6.53434 1.71043 6.61563 1.69002 6.70066C1.66699 6.79657 1.66699 6.89848 1.66699 7.10231Z"
                      stroke="#4A5565"
                      stroke-width="1.66667"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Report this profile
                </a>
              </div>
            </div>

            {/* Main Content Card */}
            <div class="content-card">
              <div class="card-body-custom">
                <div className="d-flex align-items-start gap-3 justify-content-between ct_flex_col_767">
                  <div className="d-flex align-items-center gap-3">
                    <img
                      src={userData?.avatar_url || "/assets/img/user_profile.png"}
                      className="ct_img_96"
                    />
                    <div>
                      <h4 className="ct_fs_22 ct_fw_600">
                        {userData?.full_name || "#N/A"}
                      </h4>
                      <p className="mb-1">
                        <svg
                          className="me-1"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.3 12.22C13.8336 11.7581 14.2616 11.1869 14.5549 10.545C14.8482 9.90316 15 9.20571 15 8.5C15 7.17392 14.4732 5.90215 13.5355 4.96447C12.5979 4.02678 11.3261 3.5 10 3.5C8.67392 3.5 7.40215 4.02678 6.46447 4.96447C5.52678 5.90215 5 7.17392 5 8.5C4.99999 9.20571 5.1518 9.90316 5.44513 10.545C5.73845 11.1869 6.16642 11.7581 6.7 12.22C5.30014 12.8539 4.11247 13.8775 3.27898 15.1685C2.4455 16.4596 2.00147 17.9633 2 19.5C2 19.7652 2.10536 20.0196 2.29289 20.2071C2.48043 20.3946 2.73478 20.5 3 20.5C3.26522 20.5 3.51957 20.3946 3.70711 20.2071C3.89464 20.0196 4 19.7652 4 19.5C4 17.9087 4.63214 16.3826 5.75736 15.2574C6.88258 14.1321 8.4087 13.5 10 13.5C11.5913 13.5 13.1174 14.1321 14.2426 15.2574C15.3679 16.3826 16 17.9087 16 19.5C16 19.7652 16.1054 20.0196 16.2929 20.2071C16.4804 20.3946 16.7348 20.5 17 20.5C17.2652 20.5 17.5196 20.3946 17.7071 20.2071C17.8946 20.0196 18 19.7652 18 19.5C17.9985 17.9633 17.5545 16.4596 16.721 15.1685C15.8875 13.8775 14.6999 12.8539 13.3 12.22V12.22ZM10 11.5C9.40666 11.5 8.82664 11.3241 8.33329 10.9944C7.83994 10.6648 7.45542 10.1962 7.22836 9.64805C7.0013 9.09987 6.94189 8.49667 7.05764 7.91473C7.1734 7.33279 7.45912 6.79824 7.87868 6.37868C8.29824 5.95912 8.83279 5.6734 9.41473 5.55764C9.99667 5.44189 10.5999 5.5013 11.1481 5.72836C11.6962 5.95542 12.1648 6.33994 12.4944 6.83329C12.8241 7.32664 13 7.90666 13 8.5C13 9.29565 12.6839 10.0587 12.1213 10.6213C11.5587 11.1839 10.7956 11.5 10 11.5ZM21.71 9.13C21.617 9.03627 21.5064 8.96188 21.3846 8.91111C21.2627 8.86034 21.132 8.8342 21 8.8342C20.868 8.8342 20.7373 8.86034 20.6154 8.91111C20.4936 8.96188 20.383 9.03627 20.29 9.13L18.29 11.13L17.67 10.5C17.577 10.4063 17.4664 10.3319 17.3446 10.2811C17.2227 10.2303 17.092 10.2042 16.96 10.2042C16.828 10.2042 16.6973 10.2303 16.5754 10.2811C16.4536 10.3319 16.343 10.4063 16.25 10.5C16.0637 10.6874 15.9592 10.9408 15.9592 11.205C15.9592 11.4692 16.0637 11.7226 16.25 11.91L17.59 13.25C17.7774 13.4363 18.0308 13.5408 18.295 13.5408C18.5592 13.5408 18.8126 13.4363 19 13.25L21.67 10.58C21.771 10.4893 21.8524 10.379 21.9094 10.2559C21.9664 10.1327 21.9977 9.99924 22.0014 9.86359C22.0052 9.72794 21.9813 9.59294 21.9312 9.46682C21.8811 9.34071 21.8058 9.22611 21.71 9.13V9.13Z"
                            fill="#414853"
                          />
                        </svg>
                        SecurPoint user since{" "}
                        {moment(userData?.createdAt).format("MMMM YYYY")}
                      </p>
                      <p className="mb-0">
                        <span className="ct_green_text">
                          {userData?.active_listing ?? 0}
                        </span>{" "}
                        {userData?.active_listing === 1
                          ? "Active Listing"
                          : "Active Listings"}
                      </p>
                    </div>
                  </div>
                  <button
                    className="ct_green_bnt px-3 gap-2"
                    data-bs-target="#mobileAppModal"
                    data-bs-toggle="modal"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.9999 2C10.6866 2 9.38629 2.25866 8.17303 2.7612C6.95978 3.26375 5.85738 4.00035 4.9288 4.92893C3.05343 6.8043 1.99987 9.34784 1.99987 12C1.99112 14.3091 2.79066 16.5485 4.25987 18.33L2.25987 20.33C2.12111 20.4706 2.02711 20.6492 1.98974 20.8432C1.95236 21.0372 1.97329 21.2379 2.04987 21.42C2.13292 21.5999 2.26757 21.7511 2.43671 21.8544C2.60586 21.9577 2.80187 22.0083 2.99987 22H11.9999C14.652 22 17.1956 20.9464 19.0709 19.0711C20.9463 17.1957 21.9999 14.6522 21.9999 12C21.9999 9.34784 20.9463 6.8043 19.0709 4.92893C17.1956 3.05357 14.652 2 11.9999 2ZM11.9999 20H5.40987L6.33987 19.07C6.52612 18.8826 6.63066 18.6292 6.63066 18.365C6.63066 18.1008 6.52612 17.8474 6.33987 17.66C5.03045 16.352 4.21504 14.6305 4.03256 12.7888C3.85007 10.947 4.31181 9.09901 5.33909 7.55952C6.36638 6.02004 7.89566 4.88436 9.66638 4.34597C11.4371 3.80759 13.3397 3.8998 15.0501 4.60691C16.7604 5.31402 18.1727 6.59227 19.0463 8.22389C19.9199 9.85551 20.2007 11.7395 19.841 13.555C19.4813 15.3705 18.5032 17.005 17.0734 18.1802C15.6436 19.3554 13.8506 19.9985 11.9999 20ZM16.9999 11H6.99987C6.73465 11 6.4803 11.1054 6.29276 11.2929C6.10522 11.4804 5.99987 11.7348 5.99987 12C5.99987 12.2652 6.10522 12.5196 6.29276 12.7071C6.4803 12.8946 6.73465 13 6.99987 13H16.9999C17.2651 13 17.5194 12.8946 17.707 12.7071C17.8945 12.5196 17.9999 12.2652 17.9999 12C17.9999 11.7348 17.8945 11.4804 17.707 11.2929C17.5194 11.1054 17.2651 11 16.9999 11ZM14.9999 15H8.99987C8.73465 15 8.4803 15.1054 8.29276 15.2929C8.10522 15.4804 7.99987 15.7348 7.99987 16C7.99987 16.2652 8.10522 16.5196 8.29276 16.7071C8.4803 16.8946 8.73465 17 8.99987 17H14.9999C15.2651 17 15.5194 16.8946 15.707 16.7071C15.8945 16.5196 15.9999 16.2652 15.9999 16C15.9999 15.7348 15.8945 15.4804 15.707 15.2929C15.5194 15.1054 15.2651 15 14.9999 15ZM8.99987 9H14.9999C15.2651 9 15.5194 8.89464 15.707 8.70711C15.8945 8.51957 15.9999 8.26522 15.9999 8C15.9999 7.73478 15.8945 7.48043 15.707 7.29289C15.5194 7.10536 15.2651 7 14.9999 7H8.99987C8.73465 7 8.4803 7.10536 8.29276 7.29289C8.10522 7.48043 7.99987 7.73478 7.99987 8C7.99987 8.26522 8.10522 8.51957 8.29276 8.70711C8.4803 8.89464 8.73465 9 8.99987 9Z"
                        fill="white"
                      />
                    </svg>
                    Message User
                  </button>
                </div>
                {userData?.notes && (
                  <div className="ct_mt_30">
                    <h3 class="ct_fs_22 ct_switzer_Semibold mb-2">
                      Owner’s Note
                    </h3>
                    <div class="ct_para_scroll ct_custom_scroll">
                      <p
                        class="asset-description ct_switzer_Regular ct_fs_17"
                        style={{ color: "#364153" }}
                      >
                        {userData?.notes}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <section class="ct_py_80 pt-0">
          {fromPage == webPaths?.MyAssets ? (
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <div class="text-center">
                    <h4 class="ct_green_text ct_fs_32 ct_fw_600 ct_switzer_Semibold">
                      Promote Asset
                    </h4>
                    <p class="mb-0 ct_text_clr_4B5563s ct_fs_18 ct_switzer_Regular">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiu
                    </p>

                    <button
                      class="ct_green_bnt px-5 mx-auto ct_mt_30 ct_border_radius_12_new"
                      style={{ background: "#00C950" }}
                      data-bs-target="#mobileAppModal"
                      data-bs-toggle="modal"
                    >
                      Boost
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <div class="d-flex align-items-center justify-content-between mb-2 ct_flex_col_575">
                    <div>
                      <h5 class="ct_fs_32 ct_switzer_Semibold">
                        {" "}
                        This User’s Assets
                      </h5>
                    </div>
                    <div className="d-flex align-items-center gap-3">
                      <a
                        class="ct_text_clr_4B5563 d-flex align-items-center"
                        onClick={() => {
                          handleShareUserProfile(id);
                        }}
                      >
                        <svg
                          class="me-2"
                          width="18"
                          height="18"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.8335 3.33337V6.66671C5.35432 7.52337 3.31682 12.3234 2.50016 16.6667C2.46932 16.8384 6.98682 11.6984 10.8335 11.6667V15L17.5002 9.16671L10.8335 3.33337Z"
                            stroke="#4A5565"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>
                        Share
                      </a>
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(webPaths?.AllAssets);
                        }}
                        class="ct_text_clr_4B5563"
                      >
                        View More <i class="fa-solid fa-angle-right ms-1"></i>
                      </a>
                    </div>
                  </div>

                  <div
                    className="position-relative ct_search ct_mt_30 w-auto ms-auto"
                    style={{ maxWidth: "300px" }}
                  >
                    <input
                      className="form-control ct_input"
                      placeholder="Search assets"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      type="text"
                      defaultValue=""
                      style={{
                        boxShadow: "rgba(0, 0, 0, 0.25) 0px 0px 9px 0px",
                        height: "40px",
                        paddingRight: "40px",
                      }}
                    />
                    <i class="fa-solid fa-magnifying-glass ct_show_eye"></i>
                  </div>
                </div>
              </div>
              <div className="ct_assets_data ct_custom_scroll pb-4">
                <div class="row ">
                  {filteredAssets?.length > 0 ? (
                    filteredAssets?.map((item, index) => (
                      <AssetCard
                        data={
                          item
                          //   {
                          //   promote: 1,
                          //   AssetImages: [
                          //     {
                          //       image_url: "/assets/img/assets_1.png",
                          //     },
                          //   ],
                          //   id: index + 1,
                          //   latitude: "",
                          //   longitude: "",
                          //   lock: index % 2 == 0 ? 1 : 0,
                          //   UIC: "6568520",
                          //   AssetName: "iPhone 15",
                          //   isStolen: index % 2 == 0 ? true : false,
                          //   AssetDetails:
                          //     "This property is not available for sale. Kindly...",
                          // }
                        }
                      />
                    ))
                  ) : (
                    <NoRecord />
                  )}
                </div>
              </div>
            </div>
          )}
        </section>
      </>
    );
  };

  if (isLoading) {
    return <Loader />;
  }

  return isLogin ? (
    <PanelLayout>{render()}</PanelLayout>
  ) : (
    <WebLayout>{render()}</WebLayout>
  );
};

export default OwnerDetail;
